import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { AppConnectedSessionModel } from '../state/core.model';


@Injectable({
  providedIn: 'root'
})
export class AppSessionsService {

  private _httpClient = inject(HttpClient);


  getAppConnectedSessions() {
    return this._httpClient.get<AppConnectedSessionModel[]>(`${environment.apiUrl}/v1/websocket-events/get-all`);
  }

}
